<template>
  <a-row class="content">
    <div class="config-content">
      <div class="info-content" v-if="isNew || showMap.showBase">
        <div class="btn" v-if="!isNew && (permissionMap['baseEdit'] || isDealLeader || isDealMember)">
          <a-button data-ga-id="项目-项目信息-点击编辑" data-ga-value="base" type="link" @click="edit" data-key="baseEditting" v-if="!baseEditting"
            >编辑</a-button
          >
          <template v-else>
            <span @click="cancelEdit" data-key="baseEditting">取消</span>
            <a-button type="link" @click="saveProject" data-key="baseEditting">保存</a-button>
          </template>
        </div>
        <a-row v-if="!isNew">
          <a-col :span="12" class="content-item">
            <!--项目阶段-->
            <div class="item-title">项目阶段</div>
            <span class="item-text">{{ project.stateName }}</span>
          </a-col>
          <a-col :span="12" class="content-item">
            <!--类型 0-未上会，1-已上会，2-Portfolio-->
            <div class="item-title-right">类型</div>
            <span class="item-text">{{ projectTypeMap[project.oldMark] || '' }}</span>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="12">
            <!--项目名称&BP-->
            <div class="content-item">
              <div class="item-title" :class="{ 'item-title-required': edittingMap.base }">项目名称</div>
              <a-auto-complete
                v-if="edittingMap.base"
                class="search-input"
                :value="project.name"
                optionLabelProp="name"
                dropdownClassName="search-dropdown"
                @search="search"
                :class="{ 'required-hint': !project.name && !isFP }"
              >
                <template slot="dataSource">
                  <a-select-option key="mention" class="search-item" disabled v-if="statusText">{{ statusText }} </a-select-option>
                  <template v-else>
                    <a-select-option
                      v-for="item in recommended"
                      :key="item.idStr + '$$' + item.name"
                      class="search-item"
                      @click="select(item)"
                      @keydown="select(item)"
                      :name="item.name"
                    >
                      <div class="logo">
                        <img :src="item.logo" />
                      </div>
                      <div class="content">
                        <div class="row1">
                          <p class="name">{{ item.name }}</p>
                          <p class="industry">{{ item.industry }}</p>
                        </div>
                        <p class="row2">{{ item.thirdName }}</p>
                      </div>
                    </a-select-option>
                  </template>
                </template>
              </a-auto-complete>
              <span v-else class="item-text">{{ project.name || '' }}</span>
              <a-tooltip placement="top" v-if="project.thirdCompanyId && !project.duplication">
                <template slot="title">
                  <span v-if="project.hasBind">已绑定烯牛数据</span>
                  <span v-else>已选择烯牛数据提供公司</span>
                </template>
                <a-button type="link"><a-icon type="link"/></a-button>
              </a-tooltip>
              <span v-else class="gap-10"></span>
              <a-button @click="unselect" v-if="project.thirdCompanyId && edittingMap.base" type="primary">
                <span v-if="project.hasBind">取消绑定</span>
                <span v-else>取消选择</span>
              </a-button>
            </div>
            <div class="select-hint" v-if="project.duplication">
              <p class="warning">
                项目名称（相似）已存在, 点击查看
                <br />
                <span v-for="dupl_project in project.duplication" :key="dupl_project.id">
                  <a href="javascript:;" @click="toProject(dupl_project.id)">{{ dupl_project.name }} </a>
                  <br />
                </span>
              </p>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="content-item">
              <div class="item-title-right">工商全称</div>
              <a-input v-if="edittingMap.base" class="input" v-model="project.fullName" @input="judgeDuplicationFullName"></a-input>
              <span v-else class="item-text">{{ project.fullName }}</span>
            </div>
            <div class="select-hint" v-if="project.duplication_fullName">
              <p class="warning">
                工商全称已存在, 点击查看
                <br />
                <span v-for="dupl_project in project.duplication_fullName" :key="dupl_project.id">
                  <a href="javascript:;" @click="toProject(dupl_project.id)">{{ dupl_project.name }} </a>
                  <br />
                </span>
              </p>
            </div>
          </a-col>
        </a-row>

        <!--一句话描述-->
        <a-row>
          <a-col :span="12">
            <div class="content-item">
              <div class="item-title" :class="{ 'item-title-required': edittingMap.base }">一句话描述</div>
              <a-input
                v-if="edittingMap.base"
                v-model="project.description"
                :class="{ 'required-hint': !project.description && !isFP }"
                class="long-input"
              ></a-input>
              <span v-else class="item-text">{{ project.description }}</span>
            </div>
          </a-col>

          <a-col :span="12">
            <div class="content-item third-name">
              <div class="item-title-right">别称</div>
              <div v-if="edittingMap.base">
                <div style="display: flex">
                  <a-input class="third-name-input" v-model="thirdNameInput" placeholder="简称/用于搜索" @pressEnter="addThirdNameTag"></a-input>
                  <a-button type="primary" @click="addThirdNameTag">添加</a-button>
                </div>
                <div v-if="thirdNameList.length > 0" class="tag-list">
                  <a-tag v-for="(i, index) in thirdNameList" closable @close="closeThirdNameTag(index)" :key="i">
                    {{ i }}
                  </a-tag>
                </div>
              </div>

              <span v-else class="item-text">{{ project.thirdName }}</span>
            </div>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="12">
            <div class="content-item">
              <div class="item-title" :class="{ 'item-title-required': edittingMap.base }">sector</div>
              <a-select
                v-if="edittingMap.base"
                size="default"
                v-model="project.sectorName"
                :class="{ 'required-hint': !project.sectorId && !isFP }"
                placeholder="投资部项目领域分类"
                class="select"
                style="width: 200px"
              >
                <a-select-option v-for="(item, index) in tradeList" :key="index" :value="item.name">{{ item.name }}</a-select-option>
              </a-select>
              <span v-else class="item-text">{{ tradeMap[project.sectorId] }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="content-item">
              <div class="item-title" :class="{ 'item-title-required': edittingMap.base }">大赛道</div>
              <a-select
                v-model="project.bigSector"
                v-if="edittingMap.base"
                mode="multiple"
                placeholder="项目所属大赛道（可多选）"
                :filterOption="false"
                notFoundContent="暂无数据"
                class="select"
                style="width: 210px"
              >
                <a-select-option v-for="v in bigSectorList" :key="v">{{ v }}</a-select-option>
              </a-select>
              <span v-else class="item-text">{{ project.bigSector.join(', ') }}</span>
            </div>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="12">
            <div class="content-item">
              <div class="item-title" :class="{ 'item-title-required': edittingMap.base }">融资阶段</div>
              <a-select
                v-if="edittingMap.base"
                size="default"
                v-model="project.financingStage"
                class="select"
                :class="{ 'required-hint': !project.financingStage && !isFP }"
                style="width: 200px"
              >
                <a-select-option v-for="(name, key) in financingStageMap" :key="key" :value="+key">{{ name }}</a-select-option>
              </a-select>
              <span v-else class="item-text">{{ financingStageMap[project.financingStage] }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="content-item">
              <div class="item-title-right" :class="{ 'item-title-required': edittingMap.base }">币种</div>
              <a-select
                v-if="edittingMap.base"
                size="default"
                v-model="project.currency"
                :class="{ 'required-hint': !project.currency && !isFP }"
                placeholder="用于统计，如出差报销"
                style="width: 200px"
                :disabled="project.currencyFixed"
              >
                <a-select-option v-for="(name, key) in currencyMapProject" :key="key" :value="+key">{{ name }}</a-select-option>
              </a-select>
              <span v-else class="item-text">{{ currencyMapProject[project.currency] }}</span>
              <span v-if="edittingMap.base && project.currencyFixed" class="currency-info">币种已和百川绑定不支持修改</span>
            </div>
          </a-col>
        </a-row>

        <!--source-->
        <div>
          <a-row>
            <a-col :span="12">
              <div class="content-item">
                <div class="item-title">首次Sourcing</div>
                <div class="item-title" :class="{ 'item-title-required': edittingMap.base }" style="min-width: 100px; width: 100px">内部关联人</div>
                <select-member
                  :canEdit="edittingMap.base"
                  :userlist="members.sourceInsideIds"
                  @chose="choseUserIds('sourceInsideIds', $event)"
                  @delChosenUser="delUserIds('sourceInsideIds', $event)"
                  class="member-select-item"
                  :multiChoose="false"
                  bold
                ></select-member>
              </div>
            </a-col>
            <a-col :span="10">
              <div class="content-item">
                <div class="item-title-right">外部关联人</div>
                <a-input v-if="edittingMap.base" v-model="project.sourceOutsideDesc"></a-input>
                <span v-else class="item-text">{{ project.sourceOutsideDesc }}</span>
              </div>
            </a-col>
          </a-row>
        </div>

        <!--项目打分-->
        <a-row>
          <a-col :span="12">
            <div class="content-item">
              <div class="item-title" :class="{ 'item-title-required': seedRequired && edittingMap.base }">时间优先级</div>
              <a-select
                :class="{ 'required-hint': seedRequired && !(project['priority'] || project['priority'] === 0) && !isFP }"
                v-if="edittingMap.base"
                size="default"
                v-model="project.priority"
                style="width: 200px"
                placeholder="请选择"
              >
                <a-select-option v-for="(name, key) in priorityMap" :key="key" :value="+key">{{ name }}</a-select-option>
              </a-select>
              <span v-else class="item-text">{{ priorityMap[project.priority] }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="content-item">
              <div class="item-title-right" :class="{ 'item-title-required': seedRequired && edittingMap.base }">综合分数</div>
              <a-input-number
                :class="{ 'required-hint': seedRequired && !(project['compositeScore'] || project['compositeScore'] === 0) && !isFP }"
                :min="1"
                :max="10"
                v-if="edittingMap.base"
                v-model="project.compositeScore"
                placeholder="请输入0~10之间的数字"
                class="input"
                :precision="1"
              >
              </a-input-number>
              <span v-else class="item-text">{{ project.compositeScore }}</span>
            </div>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <div class="content-item">
              <div>首次sourcing方式</div>
              <a-select v-if="edittingMap.base" size="default" v-model="project.sourceType" style="width: 75%" placeholder="请选择">
                <a-select-option v-for="item in sourceTypes" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
              <span v-else class="item-text">{{ (sourceTypes.find(i => i.id === project.sourceType) || {}).name }}</span>
            </div>
          </a-col>
        </a-row>
        <a-row v-if="project.sourceType">
          <a-col :span="24">
            <div class="content-item">
              <div>sourcing方式备注</div>
              <a-input v-if="edittingMap.base" v-model="project.sourceRemark" style="width: 75%" placeholder="请输入"> </a-input>
              <span v-else class="item-text">{{ project.sourceRemark }}</span>
            </div>
          </a-col>
        </a-row>

        <a-row v-if="project.financingStage === 1">
          <a-col :span="12">
            <div class="content-item">
              <div class="item-title" :class="{ 'item-title-required': seedRequired && edittingMap.base }">市场机会分数</div>
              <a-input-number
                :class="{ 'required-hint': seedRequired && !(project['marketScore'] || project['marketScore'] === 0) && !isFP }"
                :min="1"
                :max="10"
                v-if="edittingMap.base"
                v-model="project.marketScore"
                placeholder="请输入0~10之间的数字"
                class="input"
                :precision="1"
              >
              </a-input-number>
              <span v-else class="item-text">{{ project.marketScore }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="content-item">
              <div class="item-title-right" :class="{ 'item-title-required': seedRequired && edittingMap.base }">团队分数</div>
              <a-input-number
                :class="{ 'required-hint': seedRequired && !(project['teamScore'] || project['teamScore'] === 0) && !isFP }"
                :min="1"
                :max="10"
                v-if="edittingMap.base"
                v-model="project.teamScore"
                placeholder="请输入0~10之间的数字"
                class="input"
                :precision="1"
              >
              </a-input-number>
              <span v-else class="item-text">{{ project.teamScore }}</span>
            </div>
          </a-col>
        </a-row>

        <a-row v-if="project.financingStage === 1">
          <a-col :span="12">
            <div class="content-item">
              <div class="item-title" :class="{ 'item-title-required': seedRequired && edittingMap.base }">产品/技术分数</div>
              <a-input-number
                :class="{ 'required-hint': seedRequired && !(project['productScore'] || project['productScore'] === 0) && !isFP }"
                :min="1"
                :max="10"
                v-if="edittingMap.base"
                v-model="project.productScore"
                placeholder="请输入0~10之间的数字"
                class="input"
                :precision="1"
              >
              </a-input-number>
              <span v-else class="item-text">{{ project.productScore }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="content-item">
              <div class="item-title-right" :class="{ 'item-title-required': seedRequired && edittingMap.base }">估值匹配分数</div>
              <a-input-number
                :class="{ 'required-hint': seedRequired && !(project['valuationMatchScore'] || project['valuationMatchScore'] === 0) && !isFP }"
                :min="1"
                :max="10"
                v-if="edittingMap.base"
                v-model="project.valuationMatchScore"
                placeholder="请输入0~10之间的数字"
                class="input"
                :precision="1"
              ></a-input-number>
              <span v-else class="item-text">{{ project.valuationMatchScore }}</span>
            </div>
          </a-col>
        </a-row>

        <!-- 关联KP -->
        <a-row v-if="project.financingStage === 1 && isNew">
          <a-col :span="22">
            <div class="content-item">
              <div class="item-title" style="margin-right: 16px">关联KP</div>

              <a-tag color="blue" v-for="i in kpList" :key="i.kpId + i.position">
                <a-icon type="user" style="margin-right: 2px" />{{ i.position }}
                <span class="item-text" style="padding: 0">
                  {{ i.kpName }}
                </span>
              </a-tag>

              <a-button type="primary" shape="circle" icon="edit" size="small" @click="showKpEdit" />
            </div>
          </a-col>
        </a-row>
        <!-- 关联KP end -->

        <!-- 视频介绍 -->
        <a-row v-if="project.financingStage === 1">
          <a-col :span="22" class="content-item" style="align-items: center">
            <div class="item-title">视频介绍</div>
            <!-- radio -->
            <a-radio-group style="padding: 0 20px" v-if="edittingMap.base" v-model="project.videoPresentationType" @change="changevideoPresentation">
              <a-radio :value="1">视频链接</a-radio>
              <a-radio :value="0">视频文件</a-radio>
            </a-radio-group>
            <a v-else-if="project.videoPresentation" class="item-text" @click="toVideoPreview">点击查看</a>
            <span v-else class="item-text"></span>
          </a-col>
        </a-row>

        <a-row v-if="project.financingStage === 1 && edittingMap.base">
          <a-col :span="22" class="content-item">
            <div class="item-title"></div>
            <div class="flex-column">
              <a-input
                v-show="project.videoPresentationType === 1"
                style="width: 400px"
                v-model="videoPresentationInput"
                placeholder="请输入视频链接"
                @change="handleVideoInputChange"
              ></a-input>
              <span v-show="project.videoPresentationType === 1" class="info">视频链接需要以http/https开始</span>
            </div>
            <!-- upload -->
            <div v-show="project.videoPresentationType === 0" style="padding: 0 20px">
              <a-upload
                v-show="!videoPresentationUpload"
                name="file"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="uploadAction"
                :headers="headers"
                @change="handleVideoChange"
                accept=".mp4,.MP4,.MOV,.mov"
                :before-upload="beforeUpload"
              >
                <div>
                  <a-icon :type="videoLoading ? 'loading' : 'plus'" />
                  <div class="ant-upload-text">上传视频</div>
                </div>
              </a-upload>
              <div class="video-preview" v-show="videoPresentationUpload">
                <div class="delete-video">
                  <a-icon class="delete-video-icon" type="delete" @click.native="videoPresentationUpload = ''"></a-icon>
                </div>
                <video :src="videoPresentationUpload"></video>
              </div>
              <span class="info">视频大小需在600Mb以内，格式支持.mov/.mp4</span>
            </div>
          </a-col>
        </a-row>

        <!-- 注册情况 -->
        <a-row v-if="project.financingStage === 1">
          <a-col :span="22">
            <div class="content-item">
              <div class="item-title">注册情况</div>
              <span :class="{ 'item-text': !edittingMap.base, 'item-text-edit': edittingMap.base }">
                <span v-if="project.thirdCompanyId && project.registerAreaFromXiniu">已注册（数据取自烯牛）</span>
                <span v-else-if="project.thirdCompanyId && !project.registerAreaFromXiniu">未注册（数据取自烯牛）</span>
                <a v-else>暂未绑定烯牛项目</a>
              </span>
            </div>
          </a-col>
        </a-row>

        <!-- 注册地（区） -->
        <a-row>
          <a-col :span="22">
            <div class="content-item">
              <div class="item-title">注册地(区)</div>
              <span v-if="edittingMap.base">
                <div v-if="project.thirdCompanyId && project.registerAreaFromXiniu" style="margin-left: 16px">
                  {{ project.registerAreaFromXiniu }}（数据取自烯牛）
                </div>
                <a-input v-if="edittingMap.base" v-model="project.registerArea" placeholder="请输入" style="width: 100%"> </a-input>
              </span>
              <span v-else class="item-text">
                <div v-if="project.thirdCompanyId && project.registerAreaFromXiniu">{{ project.registerAreaFromXiniu }}（数据取自烯牛）</div>
                <span v-if="project.registerArea">{{ project.registerArea }}（DT填写）</span>
              </span>
            </div>
          </a-col>
        </a-row>

        <!-- 落地诉求 -->
        <a-row>
          <a-col :span="22">
            <div class="content-item">
              <div class="item-title">落地诉求</div>
              <a-textarea
                :rows="4"
                v-if="edittingMap.base"
                v-model="project.registerRequire"
                placeholder="之前有上会项目回复没需求，实际IC跟公司聊得时候，已经有多个政府在竞争，其他投资机构也推荐了不少地方。为了避免这类情况，我们会尽量详细收集信息，请大家询问公司，不要主观判断，谢谢理解"
                class="input"
              >
              </a-textarea>
              <span v-else-if="project.registerRequire" class="item-text">{{ project.registerRequire }}（DT填写）</span>
            </div>
          </a-col>
        </a-row>

        <!-- 跟投情况 -->
        <a-row v-if="project.financingStage && project.financingStage !== 1">
          <a-col :span="22">
            <div class="content-item">
              <div class="item-title">跟投情况</div>
              <a-input v-if="edittingMap.base" v-model="project.followOnInfo" placeholder="请输入" class="input" style="width: 100%"> </a-input>
              <span v-else-if="project.followOnInfo" class="item-text">{{ project.followOnInfo }}（DT填写）</span>
            </div>
          </a-col>
        </a-row>

        <!-- 项目最大亮点 -->
        <a-row v-if="project.financingStage === 1">
          <a-col :span="22">
            <div class="content-item">
              <div class="item-title">项目最大亮点</div>
              <a-textarea :rows="4" v-if="edittingMap.base" v-model="project.highlight" placeholder="请输入" class="input"> </a-textarea>
              <span v-else class="item-text">{{ project.highlight }}</span>
            </div>
          </a-col>
        </a-row>

        <a-row v-if="project.financingStage === 1">
          <a-col :span="22">
            <div class="content-item">
              <div class="item-title" :class="{ 'item-title-required': seedRequired && edittingMap.base }">关键问题</div>
              <a-textarea
                :class="{ 'required-hint': seedRequired && !project.keyProblem && !isFP }"
                :rows="4"
                v-if="edittingMap.base"
                v-model="project.keyProblem"
                placeholder="请输入"
                class="input"
              >
              </a-textarea>
              <span v-else class="item-text">{{ project.keyProblem }}</span>
            </div>
          </a-col>
        </a-row>
        <a-row v-if="project.financingStage === 1">
          <a-col :span="22">
            <div class="content-item">
              <div class="item-title" :class="{ 'item-title-required': seedRequired && edittingMap.base }">Deal Term</div>
              <a-textarea
                :class="{ 'required-hint': seedRequired && !project.dealTerm && !isFP }"
                :rows="4"
                v-if="edittingMap.base"
                v-model="project.dealTerm"
                placeholder="请输入"
                class="input"
              >
              </a-textarea>
              <span v-else class="item-text">{{ project.dealTerm }}</span>
            </div>
          </a-col>
        </a-row>

        <a-row v-if="project.financingStage === 1">
          <a-col :span="22">
            <div class="content-item">
              <div class="item-title" :class="{ 'item-title-required': seedRequired && edittingMap.base }">To-Do</div>
              <a-textarea
                :class="{ 'required-hint': seedRequired && !project.todo && !isFP }"
                :rows="4"
                v-if="edittingMap.base"
                v-model="project.todo"
                placeholder="请输入"
                class="input"
              >
              </a-textarea>
              <span v-else class="item-text">{{ project.todo }}</span>
            </div>
          </a-col>
        </a-row>
      </div>

      <div class="info-content" v-if="(isNew && permissionMap['secretEdit']) || (!isNew && showMap.showSecret)">
        <div class="btn" v-if="!isNew && permissionMap['secretEdit']">
          <a-button data-ga-id="项目-项目信息-点击编辑" data-ga-value="secret" type="link" @click="edit" data-key="secretEditting" v-if="!secretEditting"
            >编辑</a-button
          >
          <template v-else>
            <span @click="cancelEdit" data-key="secretEditting">取消</span>
            <a-button type="link" @click="saveProject" data-key="secretEditting">保存</a-button>
          </template>
        </div>
        <a-row>
          <a-col :span="12" class="content-item">
            <div class="item-title">保密属性</div>
            <a-select v-if="edittingMap.secret" size="default" v-model="secretInfo.secret" class="select" :disabled="!permissionMap['secretTypeEdit']">
              <a-select-option v-for="item in secretTypeList" :key="item.type" :value="item.type">{{ item.name }}</a-select-option>
            </a-select>
            <div v-else class="item-text">
              <div v-if="secretInfo.secret === 1">普通项目</div>
              <div v-if="secretInfo.secret === 2" class="secret-label secret">绝密</div>
              <div v-if="secretInfo.secret === 3" class="secret-label patent">专利</div>
            </div>
          </a-col>
          <a-col :span="12" class="content-item">
            <div class="item-title-right">交割延期保密</div>
            <a-switch v-if="edittingMap.secret" v-model="secretInfo.protect" class="left-margin" :disabled="!permissionMap['protectEdit']"></a-switch>
            <div v-else class="item-text">
              {{ secretInfo.protect ? '开启' : '关闭' }}
            </div>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12" class="content-item">
            <div class="item-title" :class="{ 'item-title-required': secretInfo.secret === 3 && edittingMap.secret }">专利标签</div>
            <a-input
              v-if="edittingMap.secret"
              size="default"
              v-model="secretInfo.patentTag"
              :class="{ 'required-hint': secretInfo.secret === 3 && !secretInfo.patentTag && !isFP, 'long-input': true }"
              :disabled="secretInfo.secret !== 3 || !permissionMap['secretTypeEdit']"
            >
            </a-input>
            <span v-else class="item-text">{{ secretInfo.patentTag }}</span>
          </a-col>
          <a-col :span="12" class="content-item">
            <div class="item-title-right" :class="{ 'item-title-required': secretInfo.protect && edittingMap.secret }">延期保密截止日</div>
            <a-date-picker
              v-if="edittingMap.secret"
              v-model="secretInfo.protectDate"
              :class="{ 'required-hint': secretInfo.protect && !secretInfo.protectDate && !isFP, 'left-margin': true }"
              :disabled="!secretInfo.protect || !permissionMap['protectEdit']"
            />
            <div v-else class="item-text">{{ protectDateText }}</div>
          </a-col>
        </a-row>
      </div>

      <div class="info-content" v-if="!isNew && showMap.showStage">
        <a-row>
          <a-col :span="12" class="content-item">
            <div class="item-title">当前轮次</div>
            <span class="item-text">{{ stageInfo.roundName }}</span>
          </a-col>
          <a-col :span="12" class="content-item">
            <div class="item-title-right">融资状态</div>
            <div class="item-text">{{ stageInfo.phase === 0 ? '发展期' : '融资期' }}</div>
          </a-col>
        </a-row>
        <a-row v-if="stageInfo.phase === 1">
          <a-col :span="12" class="content-item"> </a-col>
          <a-col :span="12" class="content-item">
            <div class="item-title-right">融资轮次</div>
            <div class="item-text">{{ stageInfo.raisingRoundName }}</div>
          </a-col>
        </a-row>
      </div>

      <div class="info-content" v-if="isNew || showMap.showMember">
        <div class="btn" v-if="!isNew && (permissionMap['memberEdit'] || isDealLeader || isDealMember)">
          <a-button data-ga-id="项目-项目信息-点击编辑" data-ga-value="people" type="link" @click="edit" data-key="peopleEditting" v-if="!peopleEditting"
            >编辑</a-button
          >
          <template v-else>
            <span @click="cancelEdit" data-key="peopleEditting">取消</span>
            <a-button type="link" @click="saveProject" data-key="peopleEditting">保存</a-button>
          </template>
        </div>
        <div class="content-item">
          <div class="item-title">项目组成员</div>
          <a-tooltip placement="bottom" v-if="!isNew">
            <template slot="title">
              <span>项目组历史</span>
            </template>
            <a-icon data-ga-id="项目-项目信息-点击项目组成员" type="history" class="his-icon item-text" @click="toMemberHistory" />
          </a-tooltip>
        </div>
        <div class="member-container">
          <div class="member-content">
            <div></div>
            <div class="content-item member-item" v-for="group in showMemberGroupList" :key="group.key">
              <div class="item-title">{{ group.name }}</div>
              <div class="member-select-item">
                <select-member
                  :width="240"
                  :userlist="members[group.key] || []"
                  @chose="choseUserIds(group.key, $event)"
                  @delChosenUser="delUserIds(group.key, $event)"
                  :canEdit="isNew || (edittingMap.people && (isDealLeader || (isDealMember && group.key !== 'dls') || permissionMap[group.key]))"
                  bold
                  :multiChoose="!(group.key === 'dls' || group.key === 'partners' || group.key === 'ddLs' || group.key === 'bps')"
                  :isOthers="group.key === 'others'"
                ></select-member>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="info-content" v-if="!isNew && showMap.showCreate">
        <a-row>
          <a-col :span="12" class="content-item">
            <div class="item-title">项目创建者</div>
            <div class="item-text">{{ createInfo.createName }}</div>
          </a-col>
          <a-col :span="12" class="content-item">
            <div class="item-title">创建时间</div>
            <div class="item-text">{{ createInfo.createAt }}</div>
          </a-col>
        </a-row>
      </div>

      <div class="content-btn clearfix">
        <a-button v-if="isNew" type="primary" class="middle-btn pull-right save-btn" @click="saveProject" :loading="saveLoading">创建</a-button>
        <a-popconfirm
          v-else-if="permissionMap.projectDelete || isDealLeader"
          class="delete-btn"
          title="确定删除该项目吗?"
          @confirm="delProject"
          @cancel="delVisible = false"
          okText="确定"
          cancelText="取消"
          data-ga-id="项目-项目信息-点击删除项目"
        >
          <a-icon slot="icon" type="question-circle-o" style="color: red" />
          <a href="#">删除项目</a>
        </a-popconfirm>
      </div>
    </div>
    <a-modal title="关联KP" :visible="kpEdit" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel" :maskClosable="false">
      <project-kp-bind v-if="kpEdit" ref="kpEdit" :kp-list="kpListTmp" @success="success" @fail="fail"></project-kp-bind>
    </a-modal>
  </a-row>
</template>

<script>
/* eslint-disable */
const getBase64 = function(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};
import { mapGetters } from 'vuex';
import { stateList } from '@/api/common';
import { sectorList } from '@/api/sector';
import {
  delProject,
  getDetail,
  searchThirdCompany,
  judgeDuplication,
  unbindThirdCompany,
  companyAdd,
  editBase,
  editSecret,
  editMember,
  getGongshangInfo
} from '@/api/project';
import { addKpToCompany } from '@/api/kp';
import selectMember from '@/components/project/selectMember';
import projectKpBind from '@/components/project/projectKpBind';
import debounce from 'lodash/debounce';
import { setTimeout } from 'timers';
import Event from '@/utils/event';
import { getToken } from '@/assets/js/auth';
import { memberGroupList, secretTypeList, projectTypeMap, financingStageMap, priorityMap } from '@/utils/project';
import { getPermissions } from '@/utils/utils';
import moment from 'moment';
import { VENTRURE_SOURCE_TYPES } from '@/const/common';

let secretTypeMap = secretTypeList.reduce((map, cur) => {
  map[cur.type] = cur.name;
  return map;
}, {});

export default {
  name: 'projectEdit',
  components: { selectMember, projectKpBind },
  props: {
    //为了逻辑清晰，增加一个props表明是新建(dialog)还是编辑(page)
    usefor: {
      type: String,
      default() {
        return 'dialog';
      }
    },
    projectId: {
      type: [String, Number],
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      /*项目信息*/
      thirdInfoTmp: {}, // 第三方信息,用于解除绑定时清空填充
      sourceTypes: VENTRURE_SOURCE_TYPES,
      thirdInfoMap: {
        logo: 'logoPath',
        id: 'thirdCompanyId',
        name: 'name',
        brief: 'description',
        // 'thirdName': 'thirdName',
        fullName: 'fullName'
      }, // 烯牛数据接口字段和前端project的字段对应关系
      thirdNameInput: '', //别称
      loading: false,
      currentUser: this.$store.state.user.userInfo,
      project: {
        bigSector: []
      },
      createInfo: {},
      // secretInfo: {},
      stageInfo: {},
      stateList: [],
      stateMap: {},
      currencyMapProject: {
        1: '人民币',
        2: '美元',
        3: '人民币及美元'
      },
      currency: undefined,
      tradeList: [],
      tradeMap: {},
      straceNameMap: {},
      projectTypeMap,
      financingStageMap,
      priorityMap,
      stateId: '',
      members: {
        dls: [],
        dms: [],
        laws: [],
        finances: [],
        backs: [],
        ddLs: [],
        ddMs: [],
        its: [],
        sourceInsideIds: [],
        cooperations: [],
        partners: [],
        bps: [],
        aims: [],
        operatorVentureIds: []
      },
      memberGroupList,
      uploadLoading: false,
      recommended: [],
      delVisible: false,
      baseEditting: false,
      peopleEditting: false,
      secretEditting: false,
      recomendFirst: false,
      saveLoading: false,
      stateName: 'Buffer',
      createPerson: '',
      createAt: '',
      secretOn: false,
      permissionMap: {},
      isDealLeader: false,
      isDealMember: false,
      secretInfo: {
        secret: 1,
        patentTag: '',
        protect: false,
        protectDate: null
      },
      secretTypeList,
      secretTypeMap,
      showMap: {
        showSecret: false,
        showBase: false,
        showCreate: false,
        showMember: false,
        showStage: true
      },
      searching: false,
      searched: false,
      projectNameTmp: '',
      seedRequiredMapScore: {
        compositeScore: '综合分数', // 数字,0-10
        priority: '项目优先级', // 数字
        marketScore: '市场分数', // 数字,0-10
        teamScore: '团队分数', // 数字,0-10
        productScore: '产品/技术分数', // 数字,0-10
        valuationMatchScore: '估值匹配分数' // 数字,0-10
      },
      seedRequiredMapString: {
        keyProblem: '关键问题', // string,1000字以内
        dealTerm: 'Deal Term', // string,1000字以内
        todo: 'To-Do' // string,1000字以内
      },
      isFP: true, // 页面第一次加载firstPrint,不展示红色必填框
      kpEdit: false,
      confirmLoading: false,
      kpList: [],
      kpListTmp: [],
      kpSearchList: [],

      uploadAction: process.env.VUE_APP_BASE_API + '/company/uploadVideoPresentation',
      videoLoading: false,
      videoPresentationInput: '',
      videoPresentationUpload: '',
      thirdNameList: [],
      bigSectorList: ['AI+', '大制造', '大消费', '生物医疗', '企业服务', '其他']
    };
  },
  watch: {
    'secretInfo.protect': {
      handler(val) {
        if (!val) {
          this.secretInfo.protectDate = null;
        }
      }
    },
    'secretInfo.secret': {
      handler(val) {
        if (val !== 3) {
          this.secretInfo.patentTag = '';
        }
      }
    },
    'project.sectorName': {
      handler(val) {
        this.project.sectorId = this.straceNameMap[val];
      }
    }
  },
  computed: {
    ...mapGetters({ token: 'token', isVenture: 'user/isVenture' }),
    headers() {
      return { Authorization: this.token };
    },
    seedRequired() {
      return this.project.financingStage === 1;
    },
    edittingMap() {
      let { baseEditting, peopleEditting, secretEditting, isNew } = this;
      return {
        base: baseEditting || isNew,
        people: peopleEditting || isNew,
        secret: secretEditting || isNew
      };
    },
    isNew() {
      return this.usefor === 'dialog';
    },
    showMemberGroupList() {
      return this.memberGroupList.filter(_ => _.alwaysShow || !this.isNew);
    },
    protectDateText() {
      let { protectDate } = this.secretInfo;
      return protectDate ? moment(protectDate).format('YYYY-MM-DD') : '无';
    },
    statusText() {
      if (!this.project.name) {
        return '请搜索';
      } else if (this.searching) {
        return '搜索中';
      } else if (this.searched && !this.recommended.length) {
        return '无匹配结果';
      } else {
        return '';
      }
    }
  },
  created() {
    if (this.projectId) {
      this.getDetail();
    } else {
      this.members.dls = [this.currentUser];
      this.createPerson = this.currentUser.nickname;

      this.project = {
        videoPresentationType: 1,
        videoPresentation: ''
      };

      this.videoPresentationInput = '';
      this.videoPresentationUpload = '';
    }
    this.getSector();
    this.getStateList();
    this.initPermissions();
  },

  methods: {
    delProject() {
      delProject(this.projectId).then(res => {
        if (res.code === 200) {
          this.$router.push('/project');
        }
      });
    },
    // 行业领域列表
    async getSector() {
      const { data } = await sectorList();
      this.tradeList = data.filter(_ => {
        return _.status === 'NORMAL';
      });
      this.tradeMap = data.reduce((map, item) => {
        map[item.id] = item.name;
        return map;
      }, {});
      this.straceNameMap = data.reduce((map, item) => {
        map[item.name] = item.id;
        return map;
      }, {});
    },
    async getStateList() {
      const { data } = await stateList();
      this.stateList = data;
      this.stateMap = data.reduce((map, item) => {
        map[item.id] = item.name;
        return map;
      }, {});
    },
    choseUserIds(group, val) {
      this.members[group] = val;
    },
    delUserIds(group, user) {
      this.members[group] = this.members[group].filter(_user => _user.id !== user.id);
    },
    getDetail() {
      getDetail(this.projectId).then(res => {
        let data = res.data;
        let {
          base = {},
          create = {},
          member = {},
          secret = {},
          stage = {},
          showBase = false,
          showCreate = false,
          showMember = false,
          showSecret = false,
          showStage = false
        } = data;
        if (base) {
          this.videoPresentationInput = base.videoPresentationType === 1 ? base.videoPresentation : '';
          this.videoPresentationUpload = base.videoPresentationType === 0 ? base.videoPresentation : '';
          if (!base.videoPresentation) {
            this.videoPresentationInput = '';
            base.videoPresentation = '';
            base.videoPresentationType = 1;
          }
          let ventureInfo = {};
          if (data.showVentureInfo) {
            ventureInfo = data.ventureInfo;
          }

          this.project = {
            ...base,
            ...ventureInfo,
            sectorId: base.sectorId == 0 ? undefined : base.sectorId,
            thirdCompanyId: base.hasBind ? -1 : null,
            id: this.projectId
          };

          this.projectNameTmp = base.name;
          this.thirdNameList = this.project.thirdName ? this.project.thirdName.split(',') : [];
        }
        member['others'].forEach(item => {
          if (item.validityDay) {
            item.validityDay = moment(item.validityDay);
            item.validityValue = 0;
          } else {
            item.validityValue = 1;
          }
        });
        this.members = {
          ...member,
          sourceInsideIds: (base && base.sourceInsideIds) || []
        };
        this.createInfo = {
          ...create,
          createAt: create && create.createAt ? moment(+create.createAt).format('YYYY-MM-DD hh:mm:ss') : ''
        };
        this.secretInfo = {
          ...secret,
          protect: secret && secret.protect === 1,
          protectDate: secret && secret.protectDate ? moment(secret.protectDate) : null
        };
        this.stageInfo = stage;
        this.showMap = { showBase, showCreate, showMember, showSecret, showStage };
        this.isDealLeader = member.dls.some(_ => _.id === this.currentUser.id);
        this.isDealMember = member.dms.some(_ => _.id === this.currentUser.id);
      });
    },
    //跳转项目
    toProject(companyId) {
      window.open(window.location.origin + `/project/detail?id=${companyId}`);
    },
    checkRequired(key = 'all') {
      let { project, secretInfo, members, seedRequiredMapScore, seedRequiredMapString } = this;

      let checkResult = false;
      let baseRequired = key === 'baseEditting' || key === 'all';
      let seedRequired = (key === 'baseEditting' || key === 'all') && project.financingStage === 1;
      let secretRequired = key === 'secretEditting' || key === 'all';
      let peopleRequired = key === 'peopleEditting' || key === 'all';
      if (!project.name && baseRequired) {
        this.$message.error('项目名称不能为空');
        return checkResult;
      }
      if (!project.currency && baseRequired) {
        this.$message.error('请选择项目币种');
        return checkResult;
      }
      if (!project.description && baseRequired) {
        this.$message.error('一句话描述不能为空');
        return checkResult;
      }
      if (!project.sectorId && baseRequired) {
        this.$message.error('请选择行业领域');
        return checkResult;
      }
      // financingStage
      if (!project.financingStage && baseRequired) {
        this.$message.error('请选择融资阶段');
        return checkResult;
      }
      if (!members.sourceInsideIds && baseRequired) {
        this.$message.error('内部关联人不能为空');
        return checkResult;
      }
      // 大赛道必填
      if ((!project.bigSector || project.bigSector.length === 0) && baseRequired) {
        this.$message.error('大赛道不能为空');
        return checkResult;
      }
      // seed轮必填

      for (let key in seedRequiredMapScore) {
        if (seedRequired && !(project[key] || project[key] === 0)) {
          this.$message.error(seedRequiredMapScore[key] + '不能为空');
          return checkResult;
        }
      }

      for (let key in seedRequiredMapString) {
        if (!project[key] && seedRequired) {
          this.$message.error(seedRequiredMapString[key] + '不能为空');
          return checkResult;
        } else if (project[key] && project[key].length > 1000) {
          this.$message.error(seedRequiredMapString[key] + ' 不能超过1000字');
          return checkResult;
        }
      }

      if (project['highlight'] && project['highlight'].length > 1000) {
        this.$message.error('项目最大亮点 不能超过1000字');
        return checkResult;
      }

      // 加视频url校验
      if (project['videoPresentationType'] === 1 && project['videoPresentation']) {
        if (!this.verifyUrl(project['videoPresentation'])) {
          this.$message.error('请输入正确的视频链接');
          return checkResult;
        }
      }

      // secret必填
      if (secretRequired && secretInfo.secret === 3 && !secretInfo.patentTag) {
        this.$message.error('专利标签不能为空');
        return checkResult;
      }
      if (secretRequired && secretInfo.protect === 1 && !secretInfo.protectDate) {
        this.$message.error('请选择延期保密截止日');
        return checkResult;
      }
      if (peopleRequired && !members.dls.length) {
        this.$message.error('请选择Deal Leader');
        return checkResult;
      }
      if (peopleRequired && members.dls.length > 1) {
        this.$message.error('Deal Leader仅能选择一位');
        return checkResult;
      }
      checkResult = true;
      return checkResult;
    },
    getBaseParams() {
      let {
        name,
        currency,
        logoPath,
        thirdCompanyId,
        description,
        sectorId,
        sectorName,
        sourceOutsideDesc,
        fullName,
        financingStage,

        compositeScore,
        priority,

        marketScore,
        teamScore,
        productScore,
        valuationMatchScore,

        keyProblem,
        dealTerm,
        todo,

        highlight,
        videoPresentation,
        videoPresentationType,
        registerAreaFromXiniu,
        registerArea,
        registerRequire,
        followOnInfo,
        sourceType,
        sourceRemark,
        bigSector
      } = this.project;
      let thirdName = this.thirdNameList.join(',');
      let sourceInsideIds = (this.members.sourceInsideIds || []).map(item => item.id).join(',');
      let params = {
        currency,
        name,
        logoPath,
        thirdName,
        thirdCompanyId,
        description,
        sectorId,
        sourceOutsideDesc,
        fullName,
        sourceInsideIds,
        financingStage,
        compositeScore,
        priority,
        sourceType,
        sourceRemark,
        bigSector
      };
      return financingStage === 1
        ? {
            ...params,
            marketScore,
            teamScore,
            productScore,
            valuationMatchScore,

            keyProblem,
            dealTerm,
            todo,

            highlight,
            videoPresentation,
            videoPresentationType,
            registerAreaFromXiniu,
            registerArea,
            registerRequire,
            followOnInfo
          }
        : {
            ...params,
            registerArea,
            registerRequire,
            followOnInfo
          };
    },
    getMemberParams() {
      return this.showMemberGroupList.reduce((params, group) => {
        if (group.idKey === 'otherIds') {
          params['others'] = (this.members[group.key] || []).map(item => {
            return { id: item.id, validityDay: +item.validityValue === 1 ? '' : moment(item.validityDay).format('YYYY.MM.DD') };
          });
        } else if (['dlId', 'bpId', 'partnerId'].includes(group.idKey)) {
          params[group.idKey] = (this.members[group.key] || []).map(item => item.id).join(',');
        } else {
          params[group.idKey] = (this.members[group.key] || []).map(item => item.id);
        }
        return params;
      }, {});
    },
    getSecretParams() {
      let { protectDate, protect } = this.secretInfo;
      return {
        ...this.secretInfo,
        protect: protect ? 1 : 0,
        protectDate: protectDate ? moment(protectDate).format('YYYYMMDD') : null
      };
    },
    saveProject: _.throttle(async function(e) {
      let { key = 'all' } = e.currentTarget.dataset;
      if (!this.checkRequired(key)) {
        this.isFP = false;
        return;
      }
      // if (this.code && this.code != -100) {
      //   body.id = this.code;
      // }
      this.saveLoading = true;
      if (key === 'all') {
        this.addCompany();
      } else {
        this.editSave(key);
      }
    }, 1000),

    async addCompany() {
      if (!this.checkRequired('all')) {
        return;
      }
      let body = {
        ...this.getBaseParams(),
        ...this.getSecretParams(),
        ...this.getMemberParams()
      };
      this.saveLoading = true;
      companyAdd(body)
        .then(res => {
          if (res.code === 200) {
            let companyId = res.data;
            this.$message.success('创建成功');
            // 关联KP
            Promise.all(
              this.kpList.map(i =>
                addKpToCompany({
                  kpId: i['kpId'],
                  companyId,
                  action: 1,
                  position: i['position']
                })
              )
            ).then(res => {
              this.confirmLoading = false;
              if (res.every(item => item.code === 200)) {
                // this.$message.success('添加成功!');
                this.kpListTmp = [];
                this.kpList = [];
              } else {
                // this.$message.error('添加失败!');
              }
              this.$emit('close');
              this.$router.push({
                path: '/project/detail',
                query: {
                  id: companyId
                }
              });
            });
          }
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },

    editSave(key) {
      let editApi, body;
      if (key === 'baseEditting') {
        editApi = editBase;
        body = this.getBaseParams();
      } else if (key === 'secretEditting') {
        editApi = editSecret;
        body = this.getSecretParams();
      } else if (key === 'peopleEditting') {
        editApi = editMember;
        body = this.getMemberParams();
      }
      body.id = this.projectId;
      editApi(body)
        .then(res => {
          if (res.code === 200) {
            this.$emit('update', res.data.id);
            this.$message.success('保存成功');
            this.getDetail();
            this[key] = false;
          }
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    // 加一个方法,获得第三方公司信息
    async getThirdInfo(keyword) {
      let res = await searchThirdCompany(keyword);
      if (res.code == 200) {
        return res.data[0];
      }
      return null;
    },
    debounceSearch: debounce(function(keyword) {
      if (keyword.length > 0) {
        searchThirdCompany(keyword)
          .then(res => {
            if (res.code == 200) {
              this.recommended = [];
              res.data.forEach(item => {
                item.idStr = item.id.toString();
                this.recommended.push(item);
              });
            }
          })
          .finally(() => {
            this.searched = true;
            this.searching = false;
          });
      } else {
        this.recommended = [];
        this.$set(this.project, 'thirdCompanyId', null);
      }
    }, 800),
    search(keyword) {
      keyword = /\$\$/.test(keyword) ? keyword.split('$$')[1] : keyword;
      this.project = {
        ...this.project,
        name: keyword
      };
      this.searching = true;
      this.searched = false;
      clearTimeout(this.timer_duplication);
      if (keyword) {
        this.timer_duplication = setTimeout(() => {
          judgeDuplication(keyword)
            .then(res => {
              if (res && res.code == 200) {
                if (keyword === this.projectNameTmp) {
                  this.$set(this.project, 'duplication', false);
                } else if (keyword !== this.project.name) {
                  // 不处理
                } else {
                  this.$set(this.project, 'duplication', res.data);
                }
                this.debounceSearch(keyword);
              }
            })
            .catch(() => {
              this.searching = false;
              this.searched = true;
            });
        }, 300);
      } else {
        this.$set(this.project, 'duplication', false);
      }
      if (!keyword) {
        return;
      }
      this.$set(this.project, 'name', keyword);
    },
    judgeDuplicationFullName(input) {
      if (!this.project.fullName) {
        this.$set(this.project, 'duplication_fullName', false);
        return;
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        judgeDuplication('', this.project.fullName)
          .then(res => {
            if (res && res.code == 200) {
              if (res.data) {
                let fullName = res.data[0].fullName;
                if (fullName === this.project.fullName) {
                  this.$set(this.project, 'duplication_fullName', res.data);
                }
              }
            }
          })
          .catch(() => {});
      }, 300);
    },

    unselect() {
      //编辑，取消绑定
      if (this.project.hasBind) {
        unbindThirdCompany(this.project.id).then(res => {
          if (res.code == 200) {
            this.$set(this.project, 'thirdCompanyId', null);
            this.$set(this.project, 'hasBind', false);
          }
        });
      } else {
        //新建，取消选择
        Object.keys(this.thirdInfoTmp).forEach(_ => {
          if (_ === 'thirdName') {
            this.thirdNameList = this.thirdInfoTmp[_] ? [] : this.thirdNameList;
          } else if (this.thirdInfoTmp[_]) {
            this.$set(this.project, this.thirdInfoMap[_], null);
          }
        });
        // 单独判断thirdName
        this.thirdInfoTmp = {};
      }
    },
    async select(value) {
      let res = await judgeDuplication(value.name);
      if (res && res.code == 200) {
        if (value.name === this.projectNameTmp) {
          this.$set(this.project, 'duplication', false);
        } else {
          this.$set(this.project, 'duplication', res.data);
        }
      }
      Object.keys(value).forEach(_ => {
        if (_ === 'thirdName') {
          this.thirdNameList = value[_] ? value[_].split(',') : this.thirdNameList;
        } else if (value[_]) {
          this.$set(this.project, this.thirdInfoMap[_], value[_]);
        }
      });
      this.thirdInfoTmp = { ...value };
      this.getGongshangInfo(value.companyCode);
    },
    toInfoDetail(index) {
      Event.$emit('toInfoDetail', index);
    },
    toMemberHistory() {
      Event.$emit('toInfoDetail', 3);
    },
    edit(e) {
      let { key } = e.currentTarget.dataset;
      this[key] = true;
    },
    cancelEdit(e) {
      let { key } = e.currentTarget.dataset;
      this[key] = false;
      this.getDetail();
    },
    initPermissions() {
      let keyList = [
        'baseEdit',
        'dls',
        'dms',
        'ddLs',
        'ddMs',
        'cooperations',
        'partners',
        'laws',
        'finances',
        'backs',
        'its',
        'bps',
        'aims',
        'operatorVentureIds',
        'memberEdit',
        'secretEdit',
        'secretTypeEdit',
        'protectEdit',
        'projectDelete'
      ];
      this.permissionMap = getPermissions(keyList);
    },
    showKpEdit() {
      this.kpEdit = true;
      if (this.kpList.length === 0) {
        this.kpListTmp = [
          {
            kp: undefined,
            kpId: undefined,
            kpName: undefined,
            position: '' // 职位
          }
        ];
      } else {
        this.kpListTmp = this.kpList.map(item => {
          return {
            kp: item.kp,
            position: item.position // 职位
          };
        });
      }
    },
    handleOk(e) {
      //@ts-ignore
      this.$refs.kpEdit.submit();
    },
    handleCancel(e) {
      this.kpEdit = false;
      this.kpListTmp = [];
    },
    fail(msg) {
      this.$message.error(msg);
    },
    async success(list) {
      this.kpEdit = false;
      this.kpList = list;
    },
    changevideoPresentation(val) {
      console.log(val, this.project.videoPresentationType);
      // this.project.videoPresentation = val;
    },
    handleVideoChange(info) {
      if (info.file.status === 'uploading') {
        this.videoLoading = true;
        return;
      }
      if (info.file.status === 'done') {
        let res = info.file.response;
        if (res.code === 200) {
          this.$message.success('上传成功');
          this.videoPresentationUpload = res.data;
          this.project.videoPresentation = this.videoPresentationUpload;
        } else {
          this.$message.error(res.msg);
        }
        this.videoLoading = false;
      } else if (info.file.status === 'error') {
        this.$message.error('上传失败');
        this.videoLoading = false;
      }
    },
    beforeUpload(file) {
      const isLt500M = file.size / 1024 / 1024 < 600;
      if (!isLt500M) {
        this.$message.error(`文件大小上限为600Mb，当前文件为${file.size / 1024 / 1024}Mb，请重新上传`);
      }
      return isLt500M;
    },
    // open a new page to show the url
    toVideoPreview() {
      let url = this.project.videoPresentation;
      if (!this.isHttp(url)) {
        url = 'https://' + url;
      }
      if (this.verifyUrl(url)) {
        // 判断url类型
        // oss的走pdfView,其他的直接打开
        url = this.project.videoPresentationType === 0 ? `/pdfview?url=${encodeURIComponent(url)}&type=bpVideo` : url;
        window.open(url);
      } else {
        this.$message.error(`视频链接有误，无法跳转`);
      }
    },
    // 正则判断url是否以http开头
    isHttp(url) {
      return /^http[s]?:\/\//.test(url);
    },
    // use regex to verify whether a url is valid
    verifyUrl(url) {
      return /^(http[s]?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/.test(
        url
      );
    },
    handleVideoInputChange(e) {
      this.project.videoPresentation = this.videoPresentationInput.trim();
    },
    closeThirdNameTag(index) {
      if (this.thirdNameList.length > 0) {
        this.thirdNameList.splice(index, 1);
      }
    },
    addThirdNameTag() {
      if (this.thirdNameInput) {
        this.thirdNameList.push(this.thirdNameInput);
        this.thirdNameInput = '';
      }
    },
    async getGongshangInfo(companyCode) {
      try {
        let res = await getGongshangInfo({
          companyCode
        });
        if (res.code === 200) {
          this.$set(this.project, 'registerAreaFromXiniu', res.data.regLocation);
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.flex-column {
  display: flex;
  flex-direction: column;
  .info {
    margin: 4px 0 0 16px;
  }
}
.setting-btn {
  margin-right: 16px;
}
.noboreder {
  border: none !important;
}
.del_box {
  padding: 10px;
}
.img-28 {
  display: inline-block;
  width: 30px;
  height: 30px;
  background-color: #eee;
  background-size: 30px 30px;
}
.m-l-12 {
  margin-left: 12px;
}
.config-content {
  .select-hint {
    color: rgba(180, 180, 180, 1);
    margin: -8px 0 5px 130px;
    .warning {
      color: rgb(255, 0, 0);
      font-size: 12px;
    }
  }
  .content-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
    line-height: 30px;
    &.member-item {
      align-items: flex-start;
    }
    .item-title {
      min-width: 110px;
      width: 110px;
      font-size: 14px;
      text-align: right;
    }
    .item-title-right {
      min-width: 120px;
      width: 120px;
      font-size: 14px;
      text-align: right;
    }
    .item-title-required:before {
      content: '* ';
      color: @red;
      // margin-right: 4px;
      // font-size: 150%;
    }
    // .item-title:after {
    //   content: ':';
    //   position: relative;
    //   top: -0.5px;
    //   // margin: 0 4px 0 2px;
    // }
    .item-text {
      padding: 0 20px;
      font-weight: bold;
      span,
      div {
        font-weight: bold;
      }
    }
    .item-text-edit {
      padding: 0 16px;
      font-weight: bold;
    }
    .currency-info {
      position: absolute;
      top: 30px;
      left: 126px;
      color: @red;
      font-size: 12px;
    }
    .his-icon {
      color: @blue;
      padding-top: 8px;
    }
    .member-select-item {
      padding-left: 20px;
      line-height: 100%;
      margin-top: 1px;
    }
    input {
      width: 200px;
      margin-left: 16px;
    }
    textarea {
      // width: 200px;
      margin-left: 16px;
    }
    /deep/.ant-input-number {
      width: 200px;
      margin-left: 16px;
    }
    .long-input {
      width: 100%;
    }
    .search-input {
      width: 300px;
      input {
        width: 300px;
        margin-left: 0;
      }
    }
    .third-name-input {
      width: 140px;
      margin-right: 8px;
    }
    .tag-list {
      margin: 4px 0 -8px 16px;
    }
    .item-textarea {
      width: 600px;
      margin-left: 16px;
    }
    .logo {
      width: 80px;
      height: 80px;
    }
    .file-name {
      cursor: pointer;
      border-radius: 5px;
      background: rgb(242, 242, 242);
      padding: 4px 8px;
      display: inline-block;
      font-weight: bold;
      // color: #1E8CFA;
    }
    .avatar {
      margin-left: 5px;
      &:first-child {
        margin-left: 16px;
      }
    }
    .logo-uploader,
    .ant-select,
    .ant-dropdown-trigger,
    .item-label {
      margin-left: 16px;
    }
    .video-preview {
      border: 1px dashed #d9d9d9;
      width: 128px;
      height: 128px;
      padding: 8px;
      position: relative;
      margin: 0 8px 8px 0;
      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .info {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
    }
  }
  .content-other {
    margin-bottom: 16px;
  }
  .content-btn {
    text-align: right;
    width: 100%;
    .save-btn {
      float: right;
    }
    .delete-btn {
      // display: inline-block;
      display: flex;
      // float: right;
      align-items: center;
      justify-content: center;
      border-radius: 3px;
      height: 32px;
      width: 70px;
      margin-right: 20px;
      color: white;
      // background: rgb(0,144,250);
      background: red;
    }
  }
  .expand {
    user-select: none;
    margin: 0 0 20px 60px;
    padding: 0 8px;
    text-align: left;
    color: rgb(24, 144, 247);
    cursor: pointer;
  }
}

.search-dropdown {
  .search-item {
    display: flex;
    align-items: center;
    padding: 10px 10px;
    height: 66px;
    .logo {
      width: 50px;
      height: 50px;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .content {
      padding-top: 10px;
      margin-left: 10px;
      width: 220px;
      overflow: hidden;
      .row1 {
        display: flex;
        height: 18px;
        .name {
          font-size: 14px;
          color: rgb(160, 170, 180);
        }
        .industry {
          font-size: 12px;
          margin-left: 16px;
          color: rgb(210, 210, 210);
        }
      }
      .row2 {
        margin-top: 6px;
        height: 18px;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.member-content {
  display: flex;
  flex-wrap: wrap;
}
.member-item {
  width: 50%;
  // flex-shrink: 0;
  // display: flex;
}

.info-content {
  border: 1px solid #e9e9e9;
  border-radius: 5px;
  padding: 15px;
  margin-bottom: 40px;
  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
}
.btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  & > * {
    cursor: pointer;
  }
}
.link-btn {
  padding-left: 0;
}
.align-center {
  display: flex;
  align-items: center;
}
.select {
  width: 300px;
}
.left-margin {
  margin-left: 16px;
}
.id-card {
  margin-left: 20px;
  border: 1px solid rgba(0, 0, 0, 0.45);
  padding: 3px 7px;
}
.kp-container {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .label {
    white-space: nowrap;
    flex: 0 0 50px;
  }
}
.add {
  // border: 2px dotted #e9e9e9;
  // background-color: rgba(0, 0, 0, 0.02);
  height: 40px;
  width: 100%;
  box-sizing: border-box;
  // margin: 16px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: bold;
  color: #999;
  // color: rgba(0,0,0,0.65);
  border-radius: 4px;
  border: 1px dashed #d9d9d9;
  background-color: #fafafa;
  transition: all 0.3s ease;
}
.add:hover {
  border: 1px dashed @blue;
}

/deep/.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

/deep/.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

/deep/.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
/deep/.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

/deep/.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.delete-video {
  // border-radius: 4px;
  position: absolute;
  width: 110px;
  height: 110px;
  top: 9px;
  left: 9px;
  // margin:-8px 0 0 -8px;
  transition: all 0.3s ease;
  z-index: 100;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  .delete-video-icon {
    color: rgba(0, 0, 0, 0);
    font-size: 18px;
    transition: all 0.3s ease;
  }
}
.delete-video:hover {
  background-color: rgba(0, 0, 0, 0.3);

  .delete-video-icon {
    color: hsla(0, 0%, 100%, 0.85);
  }
  .delete-video-icon:hover {
    color: white;
  }
}
// /deep/.ant-upload.ant-upload-select-picture-card {
//   display: inherit;
//   overflow: hidden;

// }
/deep/.ant-upload-picture-card-wrapper {
  display: inherit;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<style lang="less">
@import url('./task.less');
.required-hint {
  border-color: #f5222d !important;
  textarea {
    border-color: #f5222d !important;
  }
  input {
    border-color: #f5222d !important;
  }
  .ant-select-selection {
    border-color: #f5222d;
  }
}
// .required-hint {
//   border-color: rgb(255, 183, 216)#f5222d !important;
//   textarea {
//     border-color: rgb(255, 183, 216) !important;
//   }
//   input {
//     border-color: rgb(255, 183, 216) !important;
//   }
//   .ant-select-selection {
//     border-color: rgb(255, 183, 216);
//   }
// }
</style>
